import React from 'react'

import {
  applyMiddleware,
  bindActionCreators,
  createStore,
  combineReducers,
} from 'redux'
import { connect, Provider } from 'react-redux'

import createSagaMiddleware from 'redux-saga'
import { all, fork } from 'redux-saga/effects'

import { reducers as moduleReducers } from 'modules/reducers'
import { reducers as storeReducers } from '../reducers'
import { reducer as formReducers } from 'redux-form'

import { sagas as moduleSagas } from 'modules/sagas'
import { sagas as storeSagas } from '../sagas'

import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'

import { StateInitializer } from './StateInitializer'

import { init } from '../actions'
import { selectInit } from '../selectors'

// Combined Saga
function* sagas() {
  yield all([fork(moduleSagas), fork(storeSagas)])
}

// initialize store
const initStore = () => {
  const middleware = createSagaMiddleware()

  const reducer = combineReducers({
    module: moduleReducers,
    store: storeReducers,
    form: formReducers,
  })

  const store = createStore(reducer, applyMiddleware(middleware))

  middleware.run(sagas)

  return store
}

/**
 */
export const Initializer = ({ children, usePersistor = false }) => {
  const store = initStore()

  return (
    <Provider store={store}>
      <StateInitializer>
        {usePersistor ? (
          <Persistor store={store}>{children}</Persistor>
        ) : (
          children
        )}
      </StateInitializer>
    </Provider>
  )
}

/**
 * Persistor if reducer is persistable
 */
const Persistor = ({ children, store }) => {
  const persistor = persistStore(store)

  return (
    <PersistGate loading={<span>Loading</span>} persistor={persistor}>
      {children}
    </PersistGate>
  )
}
